import { Grid2, Icon, LinearProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export function DrawerHeader(params: {
    isFullWidth?: boolean,
    children?: React.ReactNode,
    name: string,
    isLoading?: boolean,
    onClose(): void
}) {
    const theme = useTheme();
    const brandPrimary = theme.palette.primary.main;
    return (
        <>
            <div className="heading" style={{
                padding: "16px 0px 0px 16px",
                height: "48px",
                float: "left",
                width: "calc(100% - 16px)",
                backgroundColor: brandPrimary,
                color: "white"
            }}>
                <Typography variant="h5">{params.name}</Typography>
                <button className="btn btn-default button-close" style={{ marginRight: "24px", marginTop: "2px" }} onClick={params.onClose}><Icon>close</Icon></button>
            </div >

            <Grid2 container spacing={1} sx={{ marginBottom: "5px", height: "15px" }}>
                <Grid2 size={{ xs: 12 }}>
                    {params.isLoading && <LinearProgress />}
                </Grid2>
            </Grid2>
        </>
    );

}
